import { Vector3, Quaternion, Object3D, LoadingManager, PlaneGeometry, MeshBasicMaterial, DoubleSide, Mesh, Box3 } from "three";
import { gsap, Back, Quad } from 'gsap';
import $ from 'jquery';
import { green_mood, material1 } from "./texturesAndGeometries";

const vector3 = new Vector3();
// obj - your object (THREE.Object3D or derived)
// point - the point of rotation (THREE.Vector3)
// axis - the axis of rotation (normalized THREE.Vector3)
// theta - radian value of rotation
// pointIsWorld - boolean indicating the point is in world coordinates (default = false)
export function rotateAboutPoint(obj, point, axis, theta, pointIsWorld, camera) {
  pointIsWorld = (pointIsWorld === undefined) ? false : pointIsWorld;

  if (pointIsWorld) {
    obj.parent.localToWorld(obj.position); // compensate for world coordinate
  }
  obj.position.sub(point); // remove the offset
  obj.position.applyAxisAngle(axis, theta); // rotate the POSITION
  obj.position.add(point); // re-add the offset

  if (pointIsWorld) {
    obj.parent.worldToLocal(obj.position); // undo world coordinates compensation
  }
  obj.rotateOnAxis(axis, theta); // rotate the OBJECT
  obj.lookAt(camera.position);
}

//normalizes angle 0-360
export function normaliseAngle(currentAngle, degrees) {
  currentAngle += degrees;
  currentAngle = currentAngle % 360;

  if (currentAngle < 0) {
    currentAngle += 360;
  }
  return currentAngle
}

export function degrees_to_radians(degrees) {
  return degrees * (Math.PI / 180);
}

export function radians_to_degrees(radians) {
  return radians * (180 / Math.PI);
}

export function isMobile() {
  let check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

export function isPlaying(audio) {
  return audio
    && audio.currentTime > 0
    && !audio.paused
    && !audio.ended
    && audio.readyState > 2;
}

export function htmlEscaper(text) {
  if (!text) {
    return text;
  }

  const _htmlEscapeMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': '&quot;',
    "'": '&#39;',
    "/": '&#x2F;'
  }

  return String(text).replace(/[&<>"'\/]/g, function (s) {
    return _htmlEscapeMap[s];
  });
}


////to target quternion
export function animateCamera(camera, elementSelected, onStartCallback, onEndCallBack, delay = 0) {
  onStartCallback && onStartCallback();
  const startOrientation = camera.quaternion.clone();

  const targetPosition = new Vector3();
  const targetOrientation = new Quaternion();
  const targetScale = new Vector3();

  const dbConfig = elementSelected.parent.dbConfig || null;

  if (dbConfig !== null) {
    elementSelected.rotateOnAxis(new Vector3(0, 1, 0), dbConfig.rotateY * -1 || 0);
    elementSelected.rotateOnAxis(new Vector3(1, 0, 0), dbConfig.rotateX * -1 || 0);
    elementSelected.lookAt(camera.position);
  }

  elementSelected.matrixWorld.decompose(targetPosition, targetOrientation, targetScale);
  let cameraDirection = new Vector3();

  if (dbConfig !== null) {
    element.rotateOnAxis(new Vector3(1, 0, 0), dbConfig.rotateX || 0);
    element.rotateOnAxis(new Vector3(0, 1, 0), dbConfig.rotateY || 0);
  }

  gsap.to({}, {
    duration: 1,
    delay,
    ease: Back.easeOut,
    onStart: () => {
    },
    onUpdate: function () {
      camera.quaternion.copy(startOrientation).slerp(targetOrientation, this.ratio);
      camera.quaternion.normalize();
    },
    onComplete: () => {

      camera.getWorldDirection(cameraDirection);
      cameraDirection.x *= -1;
      cameraDirection.y *= -1;
      cameraDirection.z *= -1;

      camera.position.copy(cameraDirection);
      onEndCallBack && onEndCallBack();
    }
  });
};

export function pointCameraToObject(camera, elementSelected, onStartCallback, onEndCallBack) {
  onStartCallback && onStartCallback();

  if (!camera || !elementSelected || typeof elementSelected.getWorldPosition !== 'function') {
    onEndCallBack && onEndCallBack();
    return;
  }

  // Use the object's world position and let camera.lookAt() orient the camera.
  // camera.lookAt() internally compensates for the parent rig's (pivot/pivotX)
  // world rotation, so a baked rot= url yaw is handled correctly. Assigning a
  // decomposed world quaternion to the camera's local quaternion instead would
  // double-apply that pivot yaw and rotate the view by the rot offset.
  const targetCenter = new Vector3();
  elementSelected.getWorldPosition(targetCenter);

  const cameraDirection = targetCenter.clone().normalize();
  if (!Number.isFinite(cameraDirection.x) || !Number.isFinite(cameraDirection.y) || !Number.isFinite(cameraDirection.z) || cameraDirection.lengthSq() < 1e-8) {
    onEndCallBack && onEndCallBack();
    return;
  }

  const desiredWorldPosition = cameraDirection.multiplyScalar(-1);
  const parent = camera.parent;
  if (parent && typeof parent.worldToLocal === 'function') {
    camera.position.copy(parent.worldToLocal(desiredWorldPosition.clone()));
  } else {
    camera.position.copy(desiredWorldPosition);
  }
  camera.lookAt(targetCenter);

  onEndCallBack && onEndCallBack();
};

/**
 * Point camera to a CSS3D-backed scene object (anchor/mesh/component).
 * Uses world-space center from bounding box when possible, with world-position fallback.
 */
export function pointCameraToCss3DObject(camera, elementSelected, onStartCallback, onEndCallBack) {
  onStartCallback && onStartCallback();

  if (!camera || !elementSelected) {
    onEndCallBack && onEndCallBack();
    return;
  }

  const targetCenter = new Vector3();
  // Prefer stable anchor/object world position for CSS3D components.
  // Box3 center can drift when DOM content is perspective-warped.
  const getWorldPos = (obj, out) => {
    if (!obj || typeof obj.getWorldPosition !== 'function') return false;
    obj.getWorldPosition(out);
    return Number.isFinite(out.x) && Number.isFinite(out.y) && Number.isFinite(out.z);
  };
  const worldPositionResolved = (
    getWorldPos(elementSelected, targetCenter)
    || getWorldPos(elementSelected?.anchor, targetCenter)
    || getWorldPos(elementSelected?.object, targetCenter)
    || getWorldPos(elementSelected?.mesh, targetCenter)
  );
  if (!worldPositionResolved) {
    try {
      const bounds = new Box3().setFromObject(elementSelected);
      if (!bounds.isEmpty()) {
        bounds.getCenter(targetCenter);
      } else {
        onEndCallBack && onEndCallBack();
        return;
      }
    } catch (e) {
      onEndCallBack && onEndCallBack();
      return;
    }
  }

  const cameraDirection = targetCenter.clone().normalize();
  if (!Number.isFinite(cameraDirection.x) || !Number.isFinite(cameraDirection.y) || !Number.isFinite(cameraDirection.z) || cameraDirection.lengthSq() < 1e-8) {
    onEndCallBack && onEndCallBack();
    return;
  }

  const desiredWorldPosition = cameraDirection.multiplyScalar(-1);
  const parent = camera.parent;
  if (parent && typeof parent.worldToLocal === 'function') {
    camera.position.copy(parent.worldToLocal(desiredWorldPosition.clone()));
  } else {
    camera.position.copy(desiredWorldPosition);
  }
  camera.lookAt(targetCenter);
  onEndCallBack && onEndCallBack();
};



///to target position
export function animateCameraToPosition(camera, elementSelected, onStartCallback, onEndCallBack, delay = 0) {
  const startOrientation = camera.quaternion.clone();

  const targetPosition = new Vector3();
  const targetOrientation = new Quaternion();
  const targetScale = new Vector3();

  elementSelected.matrixWorld.decompose(targetPosition, targetOrientation, targetScale);
  let cameraDirection = new Vector3();

  gsap.to({}, {
    duration: 1,
    delay,
    ease: Quad.easeIn,
    onStart: () => {
      onStartCallback && onStartCallback();
    },
    onUpdate: function () {
      camera.position.lerp(targetPosition, this.ratio);
      elementSelected.material.opacity = 1.0 - this.ratio;
    },
    onComplete: () => {
      elementSelected.material.opacity = 1.0;
      camera.getWorldDirection(cameraDirection);
      cameraDirection.x *= -1;
      cameraDirection.y *= -1;
      cameraDirection.z *= -1;
      camera.position.copy(cameraDirection);
      onEndCallBack && onEndCallBack();
    }
  });
};

export function animateCameraOutro(camera, elementSelected, onStartCallback, onEndCallBack, delay = 0) {
  gsap.fromTo(
    camera,
    { fov: 100 },
    { fov: 70, delay, duration: .8, onUpdate: () => { camera.updateProjectionMatrix(); } }
  );
};


export const getSceneFromObject = (scenes, obj) => {
  let scene = {};
  Object.keys(scenes).forEach((key) => {
    if (scenes[key].objects.filter(item => item.id === obj.id).length > 0) {
      scene = scenes[key];
      return scene;
    }
  })
  return scene
}

export const getObjectFromId = (scenes, id) => {
  let objs = [];
  scenes.map(scene => {
    objs = [...objs, ...scene.objects];
  });
  return objs.filter(item => item.id === id)[0]
}
export const getObjectFromParam = (scenes, obj, param = "goToSceneId") => {
  let objs = [];
  scenes.map(scene => {
    objs = [...objs, ...scene.objects];
  });
  return objs.filter(item => item[param] === obj[param])[0]
}

export const customLoadingManager = (onLoad, onProgress, onError) => {
  onLoad = onLoad || function () { };
  onProgress = onProgress || function () { };
  onError = onError || function () { };
  const loadingManager = new LoadingManager();
  loadingManager.onLoad = onLoad;
  loadingManager.onProgress = onProgress;
  loadingManager.onProgress = onError;
  return loadingManager;
}

export const emptySelectOptions = (id) => {
  $('#' + id).find('option').remove();
}

export const closeTinyMCEMoreMenu = () => {
  $(".tox-tbtn").removeClass('tox-tbtn--enabled');
  $(".tox-tbtn").attr('aria-expanded', false);
  $(".tox-tbtn").removeAttr('aria-controls');
  $(".tox-silver-sink").html('')
}

export const isValidUrl_old = urlString => {
  var urlPattern = new RegExp('^(https?:\\/\\/)?' + // validate protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
    '(\\#[-a-z\\d_]*)?$', 'i'); // validate fragment locator
  return !!urlPattern.test(urlString);
}

export const isValidUrl = urlString => {
  let url;
  try {
    url = new URL(urlString);
  }
  catch (e) {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:";
}



export const waitForElement = (selector) => {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

// Function to create a plane
export const createPlane = (width, height, material = material1) => {
  const geometry = new PlaneGeometry(width, height);
  geometry.translate(width / 2, 0, 0);
  return new Mesh(geometry, material);
}


// Function to position and rotate planes in a circle
export const positionPlanesInCircle = (planes, radius, max, angleOffset = Math.PI / 2) => {
  max = max || planes.length;
  const angleStep = 2 * Math.PI / max;
  for (let i = 0; i < planes.length; i++) {
    const angle = angleStep * i + angleOffset;
    planes[i].position.x = radius * Math.cos(angle);
    planes[i].position.y = radius * Math.sin(angle);
    // Rotate around Y axis to face the center
    planes[i].rotation.z = angle;
  }
}


function pixelToSphericalCoords(pixelX, pixelY, textureWidth, textureHeight) {
  const longitude = (pixelX / textureWidth) * 2 * Math.PI - Math.PI; // -π to π
  const latitude = (pixelY / textureHeight) * Math.PI - Math.PI / 2; // -π/2 to π/2
  return { latitude, longitude };
}
// Example usage
// const textureWidth = 2048; // Replace with your texture's width
// const textureHeight = 1024; // Replace with your texture's height
// const { latitude, longitude } = pixelToSphericalCoords(100, 100, textureWidth, textureHeight);


function sphericalTo3DPosition(latitude, longitude, radius) {
  const x = radius * Math.cos(latitude) * Math.sin(longitude);
  const y = radius * Math.sin(latitude);
  const z = radius * Math.cos(latitude) * Math.cos(longitude);
  return new THREE.Vector3(x, y, z);
}

// Example usage
// const sphereRadius = 1; // Replace with your sphere's radius
// const position = sphericalTo3DPosition(latitude, longitude, sphereRadius);



export const areSameResource = (url1, url2) => {
  const normalizeURL = url => {
    // Normalize the URL by removing '_lowRes' if it exists
    url = url.replace('_lowRes.jpg', '.jpg');
    // Extract the pathname
    return url.startsWith('http://') || url.startsWith('https://') ? new URL(url).pathname : (url.startsWith('/') ? url : '/' + url);
  };

  const path1 = normalizeURL(url1);
  const path2 = normalizeURL(url2);

  return path1 === path2;
}

export const arePerspectiveElements = (element) => {
  const name = element?.name || element?.parent?.name;
  return ["topLeft", "topRight", "bottomRight", "bottomLeft"].includes(name);
}

export const isVraiAgentComponentMesh = (element) => {
  if (element?.type === 'vraiAgentComponent' && element?.userData?.componentKey) return true;
  let p = element?.parent;
  while (p) {
    if (p.name === 'vraiAgent') return true;
    p = p.parent;
  }
  return false;
}

/** True if the object is a vrai agent root or a component that delegates to one. */
export const isVraiAgentParent = (obj) => obj?.name === 'vraiAgent' || !!obj?.vraiAgentRoot;

/** Find root object with name 'vraiAgent' from a mesh/component. */
export const getVraiAgentRoot = (element) => {
  let p = element;
  while (p) {
    if (p.name === 'vraiAgent') return p;
    p = p.parent;
  }
  return null;
}

export const notDraggableItems = (element) => {
  return ["settings", "delete"].includes(element.name);
}

/** Mesh-local position for a perspective corner drag handle from a quad vertex. */
export const cornerHandleLocalFromVertex = (vertex, objConfig, cornerName) => {
  const offset = objConfig?.offset?.[cornerName] || {};
  const xOff = offset.x || 0;
  const yOff = offset.y || 0;
  const half = (objConfig?.cubeSize ?? 20) / 2;
  const z = vertex?.z ?? 0;
  return {
    x: vertex.x + xOff,
    y: vertex.y + half + yOff,
    z: z + 1,
  };
};

/** Quad vertex in mesh-local space from a corner drag handle position. */
export const vertexLocalFromCornerHandle = (handlePos, objConfig, cornerName) => {
  const offset = objConfig?.offset?.[cornerName] || {};
  const xOff = offset.x || 0;
  const yOff = offset.y || 0;
  const half = (objConfig?.cubeSize ?? 20) / 2;
  return {
    x: handlePos.x - xOff,
    y: handlePos.y - half - yOff,
    z: handlePos.z ?? 0,
  };
};

/// returns Vector3
export const getVectorFromDBConfig = (data) => {
  return new Vector3(data.x, data.y, data.z);
}

/**
 * Toggles fullscreen mode for the specified element
 * @param {HTMLElement} element - The element to toggle fullscreen for
 * @returns {Promise<void>} A promise that resolves when the fullscreen action completes
 */
export async function toggleFullscreen(element) {
  try {
    if (!element) {
      console.error('Element not found for fullscreen toggle');
      return;
    }

    // Check if we're currently in fullscreen mode
    const isFullscreen = document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;

    if (!isFullscreen) {
      // Enter fullscreen mode
      if (element.requestFullscreen) {
        await element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        await element.webkitRequestFullscreen();
      } else if (element.mozRequestFullScreen) {
        await element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        await element.msRequestFullscreen();
      } else {
        console.warn('Fullscreen API not supported in this browser');
      }
    } else {
      // Exit fullscreen mode
      await exitFullscreen();
    }
  } catch (error) {
    console.error('Error toggling fullscreen mode:', error);
  }
}

/**
 * Exits fullscreen mode if currently in fullscreen
 * @returns {Promise<void>} A promise that resolves when the fullscreen exit completes
 */
export async function exitFullscreen() {
  try {
    // Check if we're currently in fullscreen mode
    const isFullscreen = document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;

    if (isFullscreen) {
      // Exit fullscreen mode
      if (document.exitFullscreen) {
        await document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        await document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        await document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        await document.msExitFullscreen();
      }
    }
  } catch (error) {
    console.error('Error exiting fullscreen mode:', error);
  }
}

/**
 * Checks if the browser is currently in fullscreen mode
 * @returns {boolean} True if in fullscreen mode, false otherwise
 */
export function isFullscreen() {
  return !!(document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement);
}

/**
 * Set a meta tag with given name and content
 * @param {string} name - Meta name attribute
 * @param {string} content - Meta content attribute
 */
export function setMeta(name, content) {
  let meta = document.querySelector(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = name;
    document.head.appendChild(meta);
  }
  meta.content = content;
}

/**
 * Remove a meta tag by name
 * @param {string} name - Meta name attribute
 */
export function removeMeta(name) {
  const meta = document.querySelector(`meta[name="${name}"]`);
  if (meta) {
    meta.remove();
  }
}

/**
 * Add or update a key-value pair to a meta tag's content
 * @param {string} name - Meta name attribute
 * @param {string} key - Key to add/update
 * @param {string} value - Value for the key
 */
export function pushMeta(name, key, value) {
  let meta = document.querySelector(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = name;
    document.head.appendChild(meta);
  }

  const content = meta.content;
  if (!content) {
    meta.content = `${key}=${value}`;
    return;
  }

  const pairs = content.split(',').map(pair => pair.trim());
  const keyExists = pairs.some((pair, index) => {
    if (pair.startsWith(key + '=')) {
      pairs[index] = `${key}=${value}`;
      return true;
    }
    return false;
  });

  if (!keyExists) {
    pairs.push(`${key}=${value}`);
  }

  meta.content = pairs.join(', ');
}

/**
 * Remove a key-value pair from a meta tag's content
 * @param {string} name - Meta name attribute
 * @param {string} key - Key to remove
 */
export function unshiftMeta(name, key) {
  const meta = document.querySelector(`meta[name="${name}"]`);
  if (!meta || !meta.content) return;

  const pairs = meta.content.split(',')
    .map(pair => pair.trim())
    .filter(pair => !pair.startsWith(key + '='));

  if (pairs.length > 0) {
    meta.content = pairs.join(', ');
  } else {
    meta.remove();
  }
}

export function isIOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

export function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

export function isChrome() {
  return /Chrome/i.test(navigator.userAgent) &&
    !/Edge|OPR|SamsungBrowser|Firefox/i.test(navigator.userAgent);
}

const WORLD_LANGUAGE_NAME_TO_CODE = {
  English: 'en',
  German: 'de',
  Romanian: 'ro',
  Roumanian: 'ro',
  en: 'en',
  de: 'de',
  ro: 'ro',
};

export function worldUserLanguageToCode(userLanguage) {
  if (!userLanguage) {
    return 'en';
  }
  return WORLD_LANGUAGE_NAME_TO_CODE[userLanguage] || 'en';
}

export function isWorldLanguageSelectionHidden(worldData) {
  const value = worldData?.hideLanguageSelection;
  return value === 1 || value === true || String(value) === '1';
}

export function isChatDisabled(worldData) {
  const value = worldData?.disableChat;
  return value === 1 || value === true || String(value) === '1';
}

export function isUserListDisabled(worldData) {
  const value = worldData?.disableUserList;
  return value === 1 || value === true || String(value) === '1';
}

export function isNavigationMenuEnabled(worldData) {
  const value = worldData?.navigationMenu;
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return value.show === true || value.show === 1;
  }
  return value === 1 || value === true || String(value) === '1';
}

export function getVisibleNavigationMenuItems(worldData) {
  const items = Array.isArray(worldData?.navigationMenuItems)
    ? worldData.navigationMenuItems
    : [];
  return items.filter((item) => item && item.visible !== false);
}

export function applyNavigationFeatureVisibility({ model, chatPanel, peoplesList }) {
  if (isChatDisabled(model.sceneData)) {
    $('.world-bottom-nav__area__chat, #chat-list-navbar-button').remove();
    chatPanel?.wrapper?.remove();
  }
  if (isUserListDisabled(model.sceneData)) {
    $('.world-bottom-nav__area__people, #people-list-navbar-button').remove();
    peoplesList?.wrapper?.remove();
  }
  const navigationEnabled = isNavigationMenuEnabled(model.sceneData);
  $('.icon-compass, #locationsButton').toggleClass('disabled', !navigationEnabled);
}

export function applyForcedWorldLanguage(worldData) {
  if (!isWorldLanguageSelectionHidden(worldData)) {
    window.__forceWorldLanguageCode = null;
    return;
  }

  const langCode = worldUserLanguageToCode(worldData?.userLanguage);
  window.__forceWorldLanguageCode = langCode;

  if (typeof multiLanguagesController !== 'undefined' && multiLanguagesController.languages?.[langCode]) {
    multiLanguagesController.changeLanguage(langCode, false);
    multiLanguagesController.renderLanguage();
  }

  $('.language-button').hide();
  $('.custom-select.change_language').hide();
  $('.lang-selector').hide();
}
